export default __webpack_public_path__ + "static/media/appIcon.2bad88f6.png";